import styled from '@emotion/styled';
import { Input } from 'antd';

export const TextArea = styled(Input.TextArea)``;
